import { NegotiationHistoryState } from '../types/negotiationHistory'

export const initialState: NegotiationHistoryState = {
  messages: [],
  loading: false,
  loadingMore: false,
  error: null,
  negotiationId: null,
  hasMore: true,
  currentPage: 1,
  totalCount: 0,
}
